<script lang="ts">
  import Layout from "$app/Layouts/Admin.svelte"
  import DataTable from "$app/components/DataTable.svelte"
  import { colorBoolean, formatDate, xhr, toast } from "$app/utils"

  let props = $props()
  let user: UserType = props.user
  let plans: PlanType[] = props.plans

  const fields = [
    { key: "id", label: "ID", sorting: false },
    { key: "role", label: "Role", sorting: false },
    {
      key: "name",
      label: "Name",
      sorting: false
    },
    {
      key: "enabled",
      label: "Enabled",
      format: (d) => {
        return `<span class="${colorBoolean(d.enabled)}">${
          d.enabled ? "EN" : "DIS"
        }ABLED</span>`
      }
    },
    {
      key: "created_at",
      label: "Created On",
      format: (d) => formatDate(d.created_at),
      sorting: false
    }
  ]

  let coachFormStatus = ""
</script>

<Layout {...props}>
  <span slot="title">View User ID: {user.id}</span>

  <div class="flex justify-start">
    <a
      href="/admin/users"
      class="hover:text-blue-500 hover:underline text-gray-700 text-lg"
      >Back to Users Index</a
    >
  </div>

  <div class="mt-4 border border-gray-500 rounded-lg p-6 shadow bg-white">
    <div class="flex gap-2 py-4 items-center">
      <div>
        <img src={user.avatar_url} alt={user.name} class="w-12 h-12 mx-auto" />
        {#if user.avatar_url.match(/^data:image/)}
          <div class="text-gray-300 text-center">No Avatar</div>
        {/if}
      </div>
      <div class="px-4">
        <span class="text-base text-gray-700">Full Name:</span>
        <span class="text-lg font-bold" title="Name">{user.name}</span>
      </div>
      <div class="px-4">
        <span class="text-base text-gray-700">Status:</span>
        <span
          class="text-sm"
          class:text-green-500={user.enabled}
          class:text-red-500={!user.enabled}
        >
          {user.enabled ? "EN" : "DIS"}ABLED
        </span>
      </div>
    </div>

    <div>
      <div class="grid grid-cols-4 gap-2 h-16">
        <div>
          <span class="label-color">EMAIL</span>
          {user.email || ""}
        </div>
        <div>
          <span class="label-color">TITLE</span>
          {user.title || ""}
        </div>

        <div>
          <span class="label-color">DISPLAY NAME</span>
          {user.display_name || ""}
        </div>

        <div>
          <span class="label-color">ONBOARDING</span>
          <span
            class:text-green-500={user.onboarding_complete}
            class:text-red-500={!user.onboarding_complete}
          >
            {user.onboarding_complete ? "COMPLETE" : "INCOMPLETE"}
          </span>
        </div>
      </div>

      <div class="grid grid-cols-4 gap-2 h-16">
        <div>
          <span class="label-color">BIRTHDATE</span>
          {user.birthdate || ""}
        </div>

        <div>
          <span class="label-color">MOBILE NUMBER</span>
          {user.mobile_number || ""}
        </div>

        <div class="col-span-2">
          <span class="label-color">SIGN-IN Count</span>
          <span>
            {user.sign_in_count || ""}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-4 border border-gray-500 rounded-lg p-6 shadow bg-white">
    <h2 class="text-xl font-bold mb-4">Plans</h2>

    <DataTable {fields} data={plans} />
  </div>
</Layout>
